<nz-collapse [style.background]="'transparent'" [nzBordered]="false" [nzExpandIconPosition]="'end'">
  @for (panel of panels; track panel) {
    <nz-collapse-panel [nzHeader]="headerTmpl" [nzActive]="panel.active">
      <ng-template #headerTmpl>
        <span class="font-bold">{{ panel.header }}</span>
      </ng-template>
      <span>{{ panel.content }}</span>
    </nz-collapse-panel>
  }
</nz-collapse>
